export function formatMessage({
  responsibleName,
  referaName,
  agencyName,
  address,
  serviceOrderDescription,
  totalBudget,
  paymentMethod,
  warranty,
  haveOrNotHaveTradesman,
}) {
  return `Olá, ${responsibleName}! Meu nome é ${referaName} da Refera!

Somos responsáveis pelas manutenções da intermediária ${agencyName} onde seu imóvel está alugado.

Referente ao seu imóvel localizado em ${address}. Sua inquilina entrou em contato com a manutenção informando o seguinte: ${serviceOrderDescription}

${haveOrNotHaveTradesman} *(O laudo técnico com fotos se encontra no pdf em anexo.)*

O valor para realizar o serviço conosco, já com material e mão de obra é R$ ${totalBudget}. 

${paymentMethod}

Este serviço tem nota fiscal e ${warranty}.

*Podemos prosseguir com a manutenção? Por gentileza nos informe assim que possível para podermos avisar ao locatário.*

Fico no aguardo e agradeço desde já!`
}

export function formatMessageMeLivrei({
  responsibleName,
  agencyName,
  address,
  serviceOrderDescription,
  totalBudget,
  warrantyMonths,
  serviceOrderId,
}) {
  const warrantyInfo =
    Number(warrantyMonths) > 0
      ? `📜 Garantia: ${warrantyMonths} mês(es) + Nota Fiscal`
      : `📜 Nota Fiscal`

  return `Olá, ${responsibleName}! Sou da Refera, responsável pelas manutenções da ${agencyName}.

Referente ao seu imóvel localizado em ${address}.

Seu(sua) inquilino(a) entrou em contato com a manutenção informando o seguinte: ${serviceOrderDescription}

Para resolver isso, encaminhamos um profissional de confiança da imobiliária que analisou o problema e definiu a melhor solução. O laudo técnico com fotos está no PDF anexo.
💰 Valor do serviço (inclui material + mão de obra): R$ ${totalBudget}
${warrantyInfo}

💳 Formas de pagamento:
✅ Desconto do aluguel em até 5x com juros. (lançamento após finalização do serviço).
✅ PIX ou Boleto (pagamento antecipado)
✅ Cartão de crédito (até 10x com acréscimos)

Aprovando conosco você tem garantia total do serviço, não precisa se preocupar com agendamentos com o inquilino e ainda tem facilidade no pagamento via aluguel.

Além disso, trabalhamos apenas com profissionais capacitados e de confiança da imobiliária.

Podemos seguir com a manutenção? Aguardo seu retorno! 😊

Importante: qualquer pagamento deste serviço deve ser feito somente para a Refera ou para a imobiliária. O técnico não está autorizado a receber valores diretamente.

ID: ${serviceOrderId}`
}

export function formatMessageIntermediary({
  responsibleName,
  referaName,
  agencyName,
  address,
  serviceOrderDescription,
  totalBudget,
  paymentMethod,
  warranty,
  haveOrNotHaveTradesman,
}) {
  return `Olá, ${responsibleName}! Meu nome é ${referaName} da ${agencyName}!

Somos responsáveis pelas manutenções da intermediária ${agencyName} onde seu imóvel está alugado.

O inquilino do seu imóvel localizado em ${address} entrou em contato informando o seguinte caso: ${serviceOrderDescription}

${haveOrNotHaveTradesman} *O laudo técnico da solução com fotos se encontra no pdf em anexo.*

O valor para realizar o serviço conosco, já com material e mão de obra é R$ ${totalBudget}. 

${paymentMethod}

Este serviço tem nota fiscal e ${warranty}.

Podemos prosseguir com o serviço? Faremos com velocidade e qualidade para evitar a insatisfação do seu inquilino.`
}
